import { memo, Suspense, lazy, useCallback, useState } from "react";
import { Link, useRouterState, useNavigate } from "@tanstack/react-router";
import { Home, Search, Map, CalendarCheck } from "lucide-react";
import { MayaMark } from "./BrandLockup";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/hooks/use-auth";
const SearchDialog = lazy(() => import("./SearchDialog").then(m=>({default:m.SearchDialog})));
function BottomNavImpl() {
  const {t,i18n}=useTranslation(); const {user}=useAuth(); const navigate=useNavigate();
  const english=i18n.language.startsWith('en');
  const pathname=useRouterState({select:s=>s.location.pathname});
  const orbit=useRouterState({select:s=>Boolean((s.location.search as Record<string,unknown>)?.orbit)});
  const [searchOpen,setSearchOpen]=useState(false);const [mounted,setMounted]=useState(false);
  const homeAction=useCallback((kind:'search'|'map')=>{
    if(pathname==='/'){window.dispatchEvent(new CustomEvent(`home:${kind}`));return;}
    if(kind==='search'){setMounted(true);setSearchOpen(true);return;}
    void navigate({to:'/'}).then(()=>window.dispatchEvent(new CustomEvent('home:map')));
  },[pathname,navigate]);
  if(orbit)return null;
  return <><nav data-bottom-nav aria-label={t('nav.bottom.aria','Navegación principal')} className="home-bottom-nav">
    <Link to="/" className="home-bottom-item" aria-current={pathname==='/'?'page':undefined}><Home/><span>{english?'Home':'Inicio'}</span></Link>
    <Button variant="ghost" className="home-bottom-item" onClick={()=>homeAction('map')}><Map/><span>{english?'Map':'Mapa'}</span></Button>
    <Button className="home-bottom-search" aria-label={english?'Search':'Buscar'} onClick={()=>homeAction('search')}><Search/><span>{english?'Search':'Buscar'}</span></Button>
    <Button variant="ghost" className="home-bottom-item" onClick={()=>window.dispatchEvent(new CustomEvent('concierge:open'))}><MayaMark size={28}/><span>Maya</span></Button>
    <Link to={user?'/mi-cuenta':'/auth'} className="home-bottom-item"><CalendarCheck/><span>{english?'Bookings':'Reservas'}</span></Link>
  </nav>{mounted&&<Suspense fallback={null}><SearchDialog open={searchOpen} onOpenChange={setSearchOpen}/></Suspense>}</>;
}
export const BottomNav=memo(BottomNavImpl);
